import AdvertisementWrapper, { AdvertisementWrapperProps } from './components/advertisement-wrapper';

const RenderAd = (props: AdvertisementWrapperProps) => {
	return <AdvertisementWrapper {...props} />;
};

export default RenderAd;
